var site;

site = site || {};

(function ($) {
  Drupal.behaviors.hotspotTextV1 = {
    isRTL: site.direction.isRTL,
    $window: $(window),
    isMobile: $('body').hasClass('device-mobile') || (Modernizr.touch && $(window).width() < 1024),
    $modules: {},
    attached: false,
    attach: function (context) {
      var self = this;

      if (self.attached) {
        return;
      }
      self.attached = true;
      var $modules = $('.js-hotspot-text', context);

      $(document).on('click', function (e) {
        if ($(e.target).closest('.hover-click').length > 0) {
          return;
        }
        $modules.find('.js-hotspot-text__highlight').removeClass('hover-click');
      });

      $modules.each(function () {
        var $thisModule = $(this);
        var $el = $thisModule.find('.js-hotspot-text__content');
        var attrObj = {};
        var i;

        if (self.isRTL) {
          $thisModule.addClass('direction-rtl');
        }

        // Gathering CMS data.
        for (i = 0; i < $thisModule[0].attributes.length; i++) {
          if ($thisModule[0].attributes[i].nodeName !== 'class') {
            attrObj[$thisModule[0].attributes[i].nodeName] = $thisModule[0].attributes[i].nodeValue;
          };
        }
        if ($el && $el.length > 0) {
          self.updateTextHighlight($el, attrObj);
        }
      });

      self.$modules = $modules;

      self.$window.on('scroll', _.throttle(function () {
        if (self.isMobile) {
          $modules.find('.js-hotspot-text__highlight').removeClass('hover-click');
        }
      }, 500));

      Unison.on('change', function () {
        self.isMobile = self.checkIfMobile();
      });
    },
    updateTextHighlight: function ($el, attrObj) {
      var highlights;
      var anchors;
      var $highlightEls;

      if (attrObj['data-text-highlight']) {
        highlights = attrObj['data-text-highlight'].split('--');
        if (attrObj['data-text-highlight-anchors']) {
          anchors = attrObj['data-text-highlight-anchors'].split(',');
        }
        this.generateHighlights($el, highlights, attrObj);
        $highlightEls = $el.find('.js-hotspot-text__highlight');
        this.setHighlightAttrs($highlightEls, anchors, attrObj);
      }
    },
    generateHighlights: function ($el, highlights, attrObj) {
      var self = this;
      var curved;
      var markup;
      var icon;
      var action;
      var j;

      for (j = 0; j < highlights.length; j++) {
        curved = attrObj['data-text-highlight-curved'] || '';
        markup = $el.html();
        if (attrObj['data-text-highlight-operation']) {
          if (attrObj['data-text-highlight-operation'] === 'js-product') {
            icon = '<div class="hotspot-text__highlight-icon js-hotspot-text__highlight-icon"></div>';
            action = '<span class="product-select js-product-select">' + highlights[j] + '</span>';
          } else {
            action = '<a>' + highlights[j] + '</a>';
            icon = '';
          }
          $el.html(markup.replace(highlights[j], '<span class="hotspot-text__highlight js-hotspot-text__highlight ' + curved + '">' + action + icon + '</span>'));
        } else if (attrObj['data-text-highlight-check']) {
          $el.html(markup.replace(highlights[j], '<span class="hotspot-text__highlight js-hotspot-text__highlight ' + curved + '"><span>' + highlights[j] + '</span></span>'));
        } else {
          $el.html(markup.replace(highlights[j], '<span class="hotspot-text__highlight js-hotspot-text__highlight ' + curved + '"><div>' + highlights[j] + '</div></span>'));
        }
      }

      if (attrObj['data-text-highlight-operation']) {
        self.renderProduct($el);
      }
    },
    setHighlightAttrs: function ($highlightEls, anchors, attrObj) {
      var self = this;

      $highlightEls.each(function (index) {
        var $highlightEl = $(this);

        self.setBackgroundColor($highlightEl, attrObj);
        self.setHighlightListeners($highlightEl, attrObj);
        self.setTextColor($highlightEl, attrObj);
        self.setHighligtSize($highlightEl, attrObj);
        self.setHighlightPadding($highlightEl, attrObj);
        self.setHighlightOperation($highlightEl, anchors, index, attrObj);
      });
    },
    renderProduct: function ($el) {
      var self = this;
      var $productSelects = $el.find('.js-product-select');
      var $productPanels = $el.siblings('.js-hotspot-text__product');
      var $productSelect;
      var $productPanel;

      $productSelects.each(function (index) {
        $productSelect = $(this);
        $productPanel = $($productPanels[index]).clone();

        self.calculateReviewWidth($productPanel);
        $productSelect.append($productPanel);
        self.setProductListener($productSelect.closest('.js-hotspot-text__highlight'));
      });

      $productPanels.remove();
    },
    calculateReviewWidth: function ($productPanel) {
      var reviewWidth = 0;
      var rating = Number($productPanel.data('rating'));

      if (rating) {
        reviewWidth = (rating / 5) * 100;
      }
      $productPanel.find('.js-hotspot-text__reviews-starssimplifiedstars').css('width', reviewWidth + '%');
    },
    setProductListener: function ($highlight) {
      var self = this;

      $highlight.off('click.product').on('click.product', function () {
        self.$modules.find('.js-hotspot-text__highlight').not($highlight).removeClass('hover-click');
        $highlight.toggleClass('hover-click');
      }).find('.js-hotspot-text__product').click(function () {
        $highlight.toggleClass('hover-click');
      });
    },
    setBackgroundColor: function ($element, attrObj) {
      var bgColor;

      if (attrObj['data-text-highlight-bgcolor']) {
        bgColor = attrObj['data-text-highlight-bgcolor'];
        if (attrObj['data-text-highlight-curved'] === '') {
          if (attrObj['data-text-highlight-check']) {
            $element.find('span').css('background-color', bgColor);
          } else {
            attrObj['data-text-highlight-check'] ? $element.find('span').css('background-color', bgColor) : $element.find('div').css('background-color', bgColor);
          }
          if ($element.find('a').length > 0) {
            $element.find('a').css('color', bgColor);
          }
        } else {
          $element.css('background-color', bgColor);
        }
      }
    },
    setHighlightListeners: function ($element, attrObj) {
      var colorWhite = '#FFFFFF';

      if (attrObj['data-text-highlight-hover-bgcolor']) {
        $element.mouseover(function () {
          $(this).css('background-color', attrObj['data-text-highlight-hover-bgcolor']);
        });
        $element.mouseout(function () {
          $(this).css('background-color', attrObj['data-text-highlight-bgcolor'] || colorWhite);
        });
      }
    },
    setTextColor: function ($element, attrObj) {
      if (attrObj['data-text-highlight-color']) {
        $element.css('color', attrObj['data-text-highlight-color']);
      }
    },
    setHighligtSize: function ($element, attrObj) {
      if (attrObj['data-text-highlight-size']) {
        $element.css('font-size', attrObj['data-text-highlight-size']);
      }
    },
    setHighlightPadding: function ($element, attrObj) {
      if (attrObj['data-text-highlight-paddings']) {
        $element.css('padding', attrObj['data-text-highlight-paddings']);
      }
    },
    setHighlightOperation: function ($element, anchors, index, attrObj) {
      if (attrObj['data-text-highlight-operation'] && attrObj['data-text-highlight-operation'] === 'js-anchor' && anchors) {
        $element.find('a').attr('href', '#' + anchors[index]);
      }
    },
    checkIfMobile: function () {
      var currentBpWidth = parseInt(Unison.fetch.now().width, 10);
      var bPlargeUp = parseInt(Unison.fetch.all()['usn-x-large'], 10);

      return currentBpWidth <= bPlargeUp;
    }
  };
})(jQuery);
